import { z } from 'zod';

import type { IdSalesPromotionDto } from '@/services/ws-funnel/src/main/resources/rest-api';

export interface PromotionDetailsRouteParams {
  promotionId?: IdSalesPromotionDto;
}

const TableTypeZod = z.enum(['ACCOUNTS', 'CONTACTS', 'ORDERS', 'OFFERS', 'DOCUMENTS']);
export const TableType = TableTypeZod.enum;
export type TableType = (typeof TableType)[keyof typeof TableType];

const SearchKeyZod = z.enum(['TABLE_TYPE']);
export const SearchKey = SearchKeyZod.enum;
export type SearchKey = (typeof SearchKey)[keyof typeof SearchKey];

export const PromotionDetailsSearchParams = z.object({
  [SearchKey.TABLE_TYPE]: TableTypeZod.optional(),
});
export type PromotionDetailsSearchParams = z.infer<typeof PromotionDetailsSearchParams>;
